import { gql } from '@apollo/client';

const GET_CURRENT_TENANT = gql`
  query GetCurrentTenant {
    me {
      id
      currentTenant {
        id
        rootFolder {
          id
        }
      }
    }
  }
`;

export default GET_CURRENT_TENANT;
